import { IState } from '../../store';

export const selectStats = (state: IState) => {
  return state.offerData.stats || null;
};
